import React, { Component } from 'react';
import { Spinner } from 'react-mdl';
import './index.css';

class Button extends Component {

    state = {
        currValue: 0,
        rafId: -1,
        mousedown: false,
        initialMouse: 0,
        slideMovementTotal: 0,
        agreed: false
    };

    constructor(prop) {
        super(prop);

        this.handleStart = this.handleStart.bind(this);
        this.handleEnd = this.handleEnd.bind(this);
        this.handleDrag = this.handleDrag.bind(this);
        this.fade = this.fade.bind(this);
        this.eventsHandleStartClick = this.eventsHandleStartClick.bind(this);
        this.eventsHandleStartTouch = this.eventsHandleStartTouch.bind(this);

        this.slider = React.createRef();
        this.background = React.createRef();
    }

    handleStart(event) {

        this.setState({ mousedown: true } || this.state.agreed);
        let slideMovementTotalVal = this.background.current.clientWidth - this.slider.current.clientWidth + 10;
        let initialMouseVal = event.clientX || event.touches[0].pageX;
        this.setState({ initialMouse: initialMouseVal });
        this.setState({ slideMovementTotal: slideMovementTotalVal });
    }
    fade(element, speed, opacity) {
        var op = opacity;  // initial opacity
        var timer = setInterval(function () {
            if (op <= opacity) {
                clearInterval(timer);
            }
            element.style.opacity = op;
            element.style.filter = 'alpha(opacity=' + op * 100 + ")";
            op -= op * opacity;
        }, speed);
    }
    eventsHandleStartTouch() {
        if (!document.getElementById('slider').classList.contains('unlocked')) {
            return;
        }
        document.getElementById('slider').classList.remove('unlocked')
        if (document.getElementById('locker')) {
            document.getElementById('locker').innerHTML = 'east';
        }
        document.getElementById('slider').removeEventListener("touchstart", function (event) {
        });
    }

    eventsHandleStartClick() {
        if (!document.getElementById('slider') && !document.getElementById('slider').classList.contains('unlocked')) {
            return;
        }
        document.getElementById('slider').classList.remove('unlocked')
        if (document.getElementById('locker')) {
            document.getElementById('locker').innerHTML = 'east';
        }
        document.getElementById('slider').removeEventListener("click", function (event) {
        });
    }

    handleEnd(event) {

        if (!this.state.mousedown || this.state.agreed) return;
        this.setState({ mousedown: false });

        var currentMouse = event.clientX || event.changedTouches[0].pageX;

        var relativeMouse = currentMouse - this.state.initialMouse;

        if (relativeMouse < this.state.slideMovementTotal) {
            this.fade(document.querySelector('.slide-text'), 50, 1)
            this.slider.current.style.left = "-2px";
            return;
        }

        if (relativeMouse >= this.state.slideMovementTotal - 50) {
            if (!this.state.agreed) {
                document.getElementById('slider').classList.add('unlocked')
                document.getElementById('locker').innerHTML = 'east';
                // const self = this
                // document.getElementById('slider').addEventListener('touchstart', function (event) {
                //     self.eventsHandleStartTouch()
                // })
                // document.getElementById('slider').addEventListener('click', function (event) {
                //     self.eventsHandleStartClick()
                // })
                setTimeout(() => this.props.onClick(), 1000);
                this.setState({ agreed: true });
            }
        }
    }

    handleDrag(event) {

        if (!this.state.mousedown || this.state.agreed) return;

        var currentMouse = event.clientX || event.touches[0].pageX;
        var relativeMouse = currentMouse - this.state.initialMouse;
        var slidePercent = 1 - relativeMouse / this.state.slideMovementTotal;

        this.fade(document.querySelector('.slide-text'), 50, slidePercent)
        if (relativeMouse <= 0) {
            this.slider.current.style.left = "-2px";
            return;
        }

        if (relativeMouse >= this.state.slideMovementTotal - 50) {
            this.slider.current.style.left = (this.state.slideMovementTotal - 12) + 'px';
            return;
        }

        this.slider.current.style.left = (relativeMouse) + 'px';
    }

    componentWillReceiveProps(nextProps) {

        this.setState({ agreed: false });
        this.slider.current.style.left = "-2px";
        if (!nextProps.isLoading) {
            this.fade(document.querySelector('.slide-text'), 50, 1)
            this.eventsHandleStartClick()
            this.eventsHandleStartTouch()
        }
    }

    render() {
        const { isLoading } = this.props


        return (
            <div className="btn-container" style={{ display: this.props.hide ? "none" : "block" }}
                onMouseMove={this.handleDrag}
                onTouchMove={this.handleDrag}
                onMouseUp={this.handleEnd}>
                <div id="button-background" ref={this.background} >
                    {/* <span className="slide-text">{this.state.mousedown && this.state ? " " : this.props.children}</span> */}
                    <span className="slide-text">{this.props.children}</span>
                    <div id="slider" ref={this.slider}
                        onTouchStart={this.handleStart}
                        onTouchEnd={this.handleEnd}
                    >
                        {/* {isLoading ? <Spinner />: <i id="locker" className="material-icons">arrow_right_alt</i>}                         */}
                        {isLoading ? <Spinner /> : <i id="locker" className="material-icons slider-icon">east</i>}
                    </div>
                </div>
            </div>
        );
    }
}

export default Button;